import Failure from '../../../core/Failure';
import { Authentication } from '@leedpulse-monorepo/classes';
import HttpClient from '../../../core/HttpClient';
import { IContact } from '@leedpulse-monorepo/interfaces';

interface SearchContactsResponse {
  hits: IContact[];
  nbHits: number;
  page: number;
}

async function searchContacts(
  auth: Authentication | null,
  query: string,
  page = 0,
  hitsPerPage = 20,
  filters?: Record<string, unknown>
): Promise<SearchContactsResponse> {
  try {
    if (!auth)
      throw new SearchContactsFailure(
        'Vous devez être connecté pour effectuer cette action.',
        'unauthorized'
      );
    const filtersBody = Object.entries(filters || {})
      .filter(([, value]) => value !== undefined && value !== null && value !== '')
      .reduce((acc: Record<string, string>, [key, value]) => {
        acc[key] = String(value);
        return acc;
      }, {});

    const params = new URLSearchParams({
      q: query,
      page: String(page),
      hitsPerPage: String(hitsPerPage),
      ...filtersBody,
    });

    const json = await HttpClient.get(
      `/algolia/search/backoffice/contacts?${params.toString()}`,
      auth.token
    );

    return { hits: json.hits, nbHits: json.nbHits, page };
  } catch (e) {
    if (e instanceof SearchContactsFailure) throw e;
    throw new SearchContactsFailure();
  }
}

export class SearchContactsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default searchContacts;
